import '/app/brewery-packages/content/content-editor-plugin-list-item/src/ListItem.css-raw';
export default {
  "listItem": "contacts-cbf4f629-listItem-zUCuRq"
};